import { render, staticRenderFns } from "./mallRenovation.vue?vue&type=template&id=34204408&scoped=true"
import script from "./mallRenovation.vue?vue&type=script&lang=js"
export * from "./mallRenovation.vue?vue&type=script&lang=js"
import style0 from "./mallRenovation.vue?vue&type=style&index=0&id=34204408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34204408",
  null
  
)

export default component.exports